// API Configuration
import { authUtil } from './auth'

// HTTP Status codes
export const HTTP_STATUS = {
  SUCCESS: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503
}

// API endpoints
export const API_ENDPOINTS = {
  // Auth endpoints
  LOGIN: '/api/auth/login',
  REGISTER: '/api/auth/register',
  SEND_SMS: '/api/auth/send-sms',
  CHANGE_PASSWORD: '/api/auth/change-password',
  LOGOUT: '/api/auth/logout',
  USER_INFO: '/api/auth/user-info',
  
  // Customers endpoints
  LEARNERS: '/api/customers',
  
  // Teachers endpoints
  TEACHERS: '/api/teachers',
  
  // Booking endpoints
  BOOKING: '/api/booking',
  
  // Charges endpoints
  CHARGES: '/api/charges',
  CHARGES_HISTORY: '/api/charges/history',
  
  // Schedules endpoints
  SCHEDULES: '/api/Schedules',
  
  // Settings endpoints
  SETTINGS: '/api/settings',
  
  // Dashboard endpoints
  DASHBOARD: '/api/dashboard',
  
  // Horse endpoints
  HORSE: '/api/horse',
  
  // Image endpoints
  IMAGE: '/api/image'
}

// Get language for request headers
function getRequestLanguage() {
  try {
    const savedLang = localStorage.getItem('yolal-language')
    return savedLang || 'zh'
  } catch (error) {
    return 'zh'
  }
}

/**
 * Build request headers with authentication
 */
export function buildRequestHeaders(method = 'GET', customHeaders = {}) {
  const normalizedMethod = (method || 'GET').toUpperCase()
  const token = authUtil.getToken()
  
  const defaultHeaders = {
    'Content-Type': normalizedMethod === 'GET' 
      ? 'application/x-www-form-urlencoded'
      : 'application/json',
    'Authorization': token ? `Bearer ${token}` : '',
    'Y-Language': getRequestLanguage()
  }
  
  return { ...defaultHeaders, ...customHeaders }
}